module.exports = __webpack_public_path__ + "static/media/SH 17.8770b566.mp3";